import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';
import queryString from 'query-string';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {AllModules, ColDef, Module} from '@ag-grid-enterprise/all-modules';
import {fromEvent, Subject, takeUntil} from 'rxjs';
import {DialogService} from 'primeng/dynamicdialog';
import {BBreadcrumb, FFields, GGridflexs} from 'src/app/models/demo';
import {NgxSpinnerService} from 'ngx-spinner';
import {cloneDeep} from 'lodash';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { AgGridFn, AgGridFnGroup } from 'src/app/common/function-common/common';

@Component({
  selector: 'app-device-activity',
  templateUrl: './device-activity.component.html',
  styleUrls: ['./device-activity.component.scss']
})
export class DeviceActivityComponent implements OnInit, OnDestroy {
  constructor(
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private router: Router) {
    this.defaultColDef = {
      resizable: true,
    };
  }

  public isLoading: boolean = true;
  private _datepipe = inject(DatePipe);
  public translate = inject(TranslateService);
  iconFilter = `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2913 3.47726H0.769231C0.344396 3.47726 0 3.14148 0 2.72726C0 2.31305 0.344396 1.97726 0.769231 1.97726H11.4465C11.8523 0.96494 12.8427 0.25 14 0.25C15.1573 0.25 16.1477 0.96494 16.5535 1.97726H19.2309C19.6557 1.97726 20.0001 2.31305 20.0001 2.72726C20.0001 3.14148 19.6557 3.47726 19.2309 3.47726H16.7087C16.4828 4.76856 15.356 5.75 14 5.75C12.644 5.75 11.5172 4.76856 11.2913 3.47726ZM12.7587 2.85147C12.753 2.90017 12.75 2.94974 12.75 3C12.75 3.69036 13.3096 4.25 14 4.25C14.6904 4.25 15.25 3.69036 15.25 3C15.25 2.30964 14.6904 1.75 14 1.75C13.3762 1.75 12.8591 2.20697 12.7652 2.80443C12.7636 2.82026 12.7614 2.83594 12.7587 2.85147Z" fill="#F3F8FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.64647 9.24997C9.32 8.09573 8.25877 7.25 7 7.25C5.74123 7.25 4.68 8.09573 4.35352 9.24997H0.769231C0.344396 9.24997 0 9.58576 0 9.99997C0 10.4142 0.344396 10.75 0.769231 10.75H4.35351C4.67996 11.9042 5.74121 12.75 7 12.75C8.25879 12.75 9.32004 11.9042 9.64649 10.75H19.2308C19.6557 10.75 20.0001 10.4142 20.0001 9.99997C20.0001 9.58576 19.6557 9.24997 19.2308 9.24997H9.64647ZM7 8.75C6.30964 8.75 5.75 9.30964 5.75 10C5.75 10.6904 6.30964 11.25 7 11.25C7.64529 11.25 8.17638 10.761 8.24297 10.1334C8.23499 10.0901 8.23083 10.0455 8.23083 9.99997C8.23083 9.95444 8.23499 9.90985 8.24296 9.86656C8.17636 9.23895 7.64528 8.75 7 8.75Z" fill="#F3F8FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.44645 18.0227H0.769231C0.344396 18.0227 0 17.6869 0 17.2727C0 16.8585 0.344396 16.5227 0.769231 16.5227H9.29127C9.51724 15.2314 10.644 14.25 12 14.25C13.356 14.25 14.4827 15.2314 14.7087 16.5227H19.2308C19.6557 16.5227 20.0001 16.8585 20.0001 17.2727C20.0001 17.6869 19.6557 18.0227 19.2308 18.0227H14.5536C14.1477 19.035 13.1574 19.75 12 19.75C10.8426 19.75 9.85227 19.035 9.44645 18.0227ZM10.75 17C10.75 16.3096 11.3096 15.75 12 15.75C12.6904 15.75 13.25 16.3096 13.25 17C13.25 17.6904 12.6904 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17Z" fill="#F3F8FF"/>
  </svg> &nbsp;&nbsp;`;
  iconSetting = `
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.2002 13.2H13.2002V10.2H14.8002V13.2H17.8002V14.8H14.8002V17.7999H13.2002V14.8H10.2002V13.2Z" fill="#F3F8FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.200195 0.199951H7.8002V7.79995H0.200195V0.199951ZM6.2002 1.79995H1.8002V6.19995H6.2002V1.79995Z" fill="#F3F8FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8002 7.79995H10.2002V0.199951H17.8002V7.79995ZM11.8002 6.19995H16.2002V1.79995H11.8002V6.19995Z" fill="#F3F8FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.200195 10.2H7.8002V17.7999H0.200195V10.2ZM6.2002 11.8H1.8002V16.2H6.2002V11.8Z" fill="#F3F8FF"/>
  </svg>`;
  pagingComponent = {
    total: 0
  };
  public modules: Module[] = AllModules;
  public agGridFn = AgGridFn;
  columns: GGridflexs[] = [];
  itemsBreadcrumb: BBreadcrumb[] = [];
  columnDefs: ColDef[] = [];
  defaultColDef: any;
  query: any = {
    filter: '',
    offSet: 0,
    pageSize: 20,
    fromDate: moment(new Date()).add(-1, 'month').format('DD/MM/YYYY'),
    toDate: moment(new Date()).format('DD/MM/YYYY')
  };
  totalRecord: number = 0;
  first: number = 0;
  countRecord: any = {
    totalRecord: 0,
    currentRecordStart: 0,
    currentRecordEnd: 0
  };
  loading: boolean = false;
  heightGrid: number = 700;
  gridKey: string = '';
  listsData: any[] = [];
  menuItem: MenuItem[] = [];
  displayDetail: boolean = false;
  Oid: string = '';
  private readonly unsubscribe$: Subject<void> = new Subject();
  displaySetting: boolean = false;


  listViewsFilter: FFields[] = [];
  cloneListViewsFilter = [];
  detailInfoFilter = null;
  optionsButonFilter = [
    {label: '_Đặt lại_', value: 'Reset', class: 'huy', icon: 'uni-icon uni-refresh', disabled: false},
    {label: '_Áp dụng_', value: 'Search', class: '', icon: 'uni-icon uni-send uni-white-color', disabled: false},
  ];
  gridApi: any;
  gridColumnApi: any = null;

  isImportFileIme = false;
  formData: any = null;
  typeApprove: string = '';
  dataSelected: any = [];
  public getRowId = (params: any) => {
    return params.data.Oid;
  };

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  cancel() {
  }

  cauhinh() {
    this.displaySetting = true;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  load() {
    this.isLoading = true;
    this.spinner.show();
    this.apiService.getListDeviceActivity()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        // WorkDate
        (results: any) => {
           this.listsData = results.map(parent => {
            // Thêm thuộc tính parentName vào mỗi đối tượng con
            return parent.sessions.map(child => {
              return {
                ...child,
                WorkDate: `${parent.os} ${parent.osVersion} - ${parent.lastAccess}`
              };
            });
          }).flat();
          this.columns = [
            {
              'columnField': 'WorkDate',
              'columnCaption': 'WorkDate',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
            {
              'columnField': 'browser',
              'columnCaption': 'browser',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
            {
              'columnField': 'expires',
              'columnCaption': 'expires',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
            {
              'columnField': 'ipAddress',
              'columnCaption': 'ipAddress',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
            {
              'columnField': 'lastAccess',
              'columnCaption': 'lastAccess',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
            {
              'columnField': 'started',
              'columnCaption': 'started',
              'columnWidth': 100,
              'fieldType': 'text',
              'cellClass': [
                'border-right',
                'd-flex',
                'align-items-center'
              ],
              'pinned': '',
              'isMasterDetail': false,
              'isStatusLable': false,
              'isHide': false,
              'isFilter': false
            },
          ];

          this.initGrid();
        });
  }

  initGrid() {
    this.columnDefs = [
     ...AgGridFnGroup(this.columns.filter((d: any) => !d.isHide)),
    ];
    this.gridApi.setColumnDefs(this.columnDefs);
  }

  find() {
    this.load();
  }

  ngOnInit() {
    const _route: any = this.route.data;
    const titlePage = _route['_value'].title;
    this.itemsBreadcrumb = [
      {label: 'Trang chủ', routerLink: '/home'},
      {label: 'Lịch sử đăng nhập'},
    ];
    // this.translate.get(['_Trang chủ_', '_Lịch sử đăng nhập_'])
    //   .subscribe(translations => {
        
    //   });
    this.load();
  }

  getContextMenuItems(params: any) {
    const result = [
      'copy',
      'paste',
      'separator',
      'excelExport'
    ];
    return result;
  }

  autoZizeAll() {
    const allColumnIds: any = [];
    this.gridColumnApi.getAllColumns()
      .forEach((column: any) => {
        if (column.colDef.cellClass && column.colDef.cellClass.indexOf('not-auto') < 0) {
          allColumnIds.push(column);
        } else {
          column.colDef.resizable = false;
        }
      });
    this.gridColumnApi.autoSizeColumns(allColumnIds, false);
  }


  rowSelected(event: any) {
    this.dataSelected = event;
  }

}


